<template>
  <v-footer fixed inset app height="auto" color="amber" class="pa-2">
    <v-layout>
      <v-spacer></v-spacer>
      <v-menu top left offset-y>
        <v-btn depressed slot="activator" color="blue darken-2 white--text" :loading="isLoading"><font-awesome-icon :icon="['fas', 'pencil']"></font-awesome-icon>&nbsp;編集する</v-btn>
        <v-list v-if="!isSuspended && !isPublished">
          <v-list-tile class="red--text">
            <v-list-tile-avatar>
              <font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>申込を削除する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider v-if="!isSuspended && !isPublished"></v-divider>
        <v-list>
          <v-list-tile v-if="isSet && !isSuspended && !isPublished"
            class="blue--text text--darken-2"
            @click.stop="$refs.agreementer.open()"
          >
            <v-list-tile-avatar>
              <font-awesome-icon :icon="['fal', 'check-circle']"></font-awesome-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>申込を確定する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.stop="$refs.programer.open({ type: 'insert' })">
            <v-list-tile-avatar>
              <font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>申込を追加する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="isSet && !isSuspended && !isPublished" @click.stop="$refs.programer.open({ type: 'update' })">
            <v-list-tile-avatar>
              <font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>申込を編集する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-layout>
    <ProgramModal ref="programer" :item="getItem" @done="update" />
    <AgreementsModal ref="agreementer" :item="getItem" @done="update" />
  </v-footer>
</template>

<script>
import ProgramModal from './modals/program'
import AgreementsModal from './modals/agreements'
export default {
  name: 'userApplyFooter',
  props: [
    'item'
  ],
  components: {
    ProgramModal,
    AgreementsModal
  },
  data () {
    return {
      config: {
        status: {
          loading: false
        }
      }
    }
  },
  methods: {
    update: function (item) {
      this.$emit('emit', {
        action: 'updateItems',
        data: item
      })
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isSet () {
      return !!(this.$props.item && this.$props.item.id)
    },
    isSuspended () {
      return (this.$props.item && this.$props.item.status === 4)
    },
    isPublished () {
      return (this.$props.item && this.$props.item.published_at && this.$props.item.published_at !== '0000-00-00 00:00:00')
    },
    isRequiredRepublish () {
      return (
        this.$props.item &&
        this.$props.item.media &&
        this.$props.item.modified_at &&
        this.$props.item.published_at &&
        this.$props.item.published_at !== this.$props.item.modified_at
      )
    },
    getItem () {
      return this.$props.item
    }
  }
}
</script>